export const ACTIVITY_EVENTS = ["pointerdown", "pointermove", "keydown", "touchstart"] as const;

export class InactivityLockController {
  private timer: number | null = null;
  private locked = false;
  private readonly activity = () => this.reset();
  private readonly visibility = () => {
    if (document.visibilityState === "visible") this.checkDeadline();
  };
  private deadline = 0;

  constructor(private readonly timeoutMs: number, private readonly onLock: () => void) {}

  start(): void {
    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, this.activity, { passive: true }));
    document.addEventListener("visibilitychange", this.visibility);
    this.reset();
  }

  stop(): void {
    ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, this.activity));
    document.removeEventListener("visibilitychange", this.visibility);
    if (this.timer !== null) window.clearTimeout(this.timer);
    this.timer = null;
  }

  unlock(): void {
    this.locked = false;
    this.reset();
  }

  lockNow(): void {
    if (this.locked) return;
    this.locked = true;
    if (this.timer !== null) window.clearTimeout(this.timer);
    this.timer = null;
    this.onLock();
  }

  private reset(): void {
    if (this.locked) return;
    this.deadline = Date.now() + this.timeoutMs;
    if (this.timer !== null) window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.checkDeadline(), this.timeoutMs);
  }

  private checkDeadline(): void {
    if (Date.now() >= this.deadline) this.lockNow();
    else this.reset();
  }
}
